var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import DockNorth from "./dockNorth";
import DockWest from "./dockWest";
import DockSouth from "./dockSouth";
import DockEast from "./dockEast";
import Previews from "../previews";
/**
 *
 * Composant Docks
 */
export default function Docks() {
    return (_jsxs("div", __assign({ className: "flex flex-row flex-auto overflow-hidden" }, { children: [_jsx(DockWest, {}), _jsxs("div", __assign({ className: "flex flex-col flex-auto overflow-hidden" }, { children: [_jsx(DockNorth, {}), _jsx(Previews, {}), _jsx(DockSouth, {})] })), _jsx(DockEast, {})] })));
}
